import { env } from '@/env'

export const useNewLoader = !env.app.isProd
